import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../authentication/auth.service';
import { ConstantService, UserRoles } from '../../../services/common/constant.service';
import { EnrollmentOptionsService } from '../../../services/common/enrollment-options';
import { EnrollmentInputModel } from '../models/enrollmentinput.model';

@Component({
  standalone: false,
  selector: 'app-enrollment-container',
  templateUrl: './enrollment-container.component.html',
  styleUrls: ['./enrollment-container.component.scss']
})
export class EnrollmentContainerComponent implements OnInit {

  
  @Input() disablePrimaryFactor: boolean;
  @Input() hidePrimaryFactor: boolean;
  @Input() skipPasswordPresence: boolean;
  @Input() onlyAwaitingEnrollment: boolean;
  @Input() isUserActive: boolean;
  @Input() userId: number;
  @Input() username: string;
  @Input() backButtonText: string = 'Button.Back';

  @Output() backPressedEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() savedEnrollmentEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  orgId: number;
  orgMnemonic: string;


  options: EnrollmentInputModel;


  constructor(
    private authService: AuthService,
    private constantService: ConstantService,
    private activatedRoute: ActivatedRoute,
    private enrollmentOptions: EnrollmentOptionsService
  ) { }

  async ngOnInit(): Promise<void> {

    this.orgId = this.authService.organizationId;
    this.orgMnemonic = this.constantService.getSubdomain();

    let userType: string = 'user';
    if (this.activatedRoute.snapshot.params['userType']) {
      userType = this.constantService.decode(this.activatedRoute.snapshot.params['userType'])
    }

    this.options = await this.enrollmentOptions.createOptions(this.orgId, this.orgMnemonic, this.userId, this.username, this.isUserActive, userType, this.disablePrimaryFactor, this.hidePrimaryFactor, false, false, false, false, this.skipPasswordPresence);
    if (this.backPressedEvent.observed) {
      this.options.style.showBackButton = true;
      this.options.style.backButtonText = this.backButtonText;
    }
    
  }

  backPressed() {
    this.backPressedEvent.emit();
  }

  savedEnrollment() {
    this.savedEnrollmentEvent.emit();
  }
}
